import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { useSettings } from "~/store/settings";
import isOperaMini from "~/utils/isOperaMini";

interface ISignalRConnection {
	id: string;
	url: string;
	reconnectInterval?: number;
}

const signalRConnection = ({ url, id, reconnectInterval = 5000 }: ISignalRConnection) => {
	const settings = useSettings();
	const shouldReconnect = ref(false);
	const logStyle = "background-color: cyan; color: #000; font-weight: bold;";

	const signalR = new HubConnectionBuilder()
		.withUrl(url, { skipNegotiation: !isOperaMini(), transport: !isOperaMini() ? 1 : 4 })
		.configureLogging(LogLevel.None)
		.build();

	async function start() {
		if (signalR.state !== "Connected") {
			try {
				await signalR.start();
				setStatus();
				shouldReconnect.value = true;
				function setStatus() {
					try {
						if (signalR.state === "Connected") {
							console.log("%cSignalR:", logStyle, `${id} Connected.`);
							if (id === "Sports") settings.signalRConnected = true;
						} else throw Error("");
					} catch (e) {
						if (shouldReconnect.value) setTimeout(setStatus, 500);
					}
				}
			} catch (err) {
				if (shouldReconnect.value) {
					console.log("%cSignalR:", logStyle, `Unable to connect to ${id}. Retrying in 5 seconds...`);
					settings.signalRConnected = false;
					setTimeout(start, reconnectInterval);
				}
			}
		}
	}

	async function stop() {
		try {
			shouldReconnect.value = false;
			handleOffline();
		} catch (e) {}
	}

	const handleOffline = () => {
		console.log("%cSignalR:", logStyle, `${id} Disconnected...`);
		settings.signalRConnected = false;
		signalR.stop();
	};

	window.addEventListener("offline", handleOffline);

	signalR.onclose(async () => {
		if (shouldReconnect.value) {
			settings.signalRConnected = false;
			await start();
		}
	});

	return {
		signalR,
		start,
		stop,
	};
};

export default signalRConnection;
